// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"86487b6c","68":"2ba0b4ff","86":"12b59ee6","148":"99a4dee5","370":"999d8d85","453":"889586fb","586":"2063373b","615":"a417d218","705":"5626e001","778":"f7583e5f","832":"ec43a6ff","937":"34ed11df"}[chunkId] + ".chunk.js";
};